import React, { useState } from 'react';
import { X, Minus, Maximize2, Minimize2, Paperclip, Link, Smile, MoreVertical, Trash2, Send, Loader2 } from 'lucide-react';
import { useForm } from 'react-hook-form';

const GmailSendMail = ({ onClose, onSend, fromEmail }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [sending, setSending] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setSending(true);
      await onSend({
        to: data.to,
        subject: data.subject,
        body: data.message
      });
    } catch (error) {
      // Error handled by parent
    } finally {
      setSending(false);
    }
  };

  if (isMinimized) {
    return (
      <div className="gmail-sendmail gmail-sendmail--minimized" data-testid="gmail-compose-minimized">
        <div className="gmail-sendmail-header" onClick={() => setIsMinimized(false)}>
          <h3>New Message</h3>
          <div className="gmail-sendmail-header-actions">
            <button className="gmail-icon-btn" onClick={(e) => { e.stopPropagation(); setIsMinimized(false); }}>
              <Maximize2 size={14} />
            </button>
            <button className="gmail-icon-btn" onClick={(e) => { e.stopPropagation(); onClose(); }}>
              <X size={14} />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`gmail-sendmail ${isMaximized ? 'gmail-sendmail--maximized' : ''}`}
      data-testid="gmail-compose"
    >
      <div className="gmail-sendmail-header">
        <h3>New Message</h3>
        <div className="gmail-sendmail-header-actions">
          <button className="gmail-icon-btn" onClick={() => setIsMinimized(true)}>
            <Minus size={14} />
          </button>
          <button className="gmail-icon-btn" onClick={() => setIsMaximized(!isMaximized)}>
            {isMaximized ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
          </button>
          <button className="gmail-icon-btn" onClick={onClose}>
            <X size={14} />
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="gmail-sendmail-form">
        {fromEmail && (
          <div className="gmail-sendmail-from">
            <span className="gmail-sendmail-from-label">From:</span>
            <span className="gmail-sendmail-from-email">{fromEmail}</span>
          </div>
        )}
        
        <div className="gmail-sendmail-field">
          <input
            type="email"
            placeholder="Recipients"
            {...register('to', { 
              required: 'Recipient is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address'
              }
            })}
            className="gmail-sendmail-input"
            data-testid="compose-to-input"
          />
          {errors.to && <span className="gmail-sendmail-error">{errors.to.message}</span>}
        </div>

        <div className="gmail-sendmail-field">
          <input
            type="text"
            placeholder="Subject"
            {...register('subject', { required: 'Subject is required' })}
            className="gmail-sendmail-input"
            data-testid="compose-subject-input"
          />
          {errors.subject && <span className="gmail-sendmail-error">{errors.subject.message}</span>}
        </div>

        <div className="gmail-sendmail-body">
          <textarea
            placeholder="Compose email"
            {...register('message', { required: 'Message is required' })}
            className="gmail-sendmail-textarea"
            data-testid="compose-message-input"
          />
          {errors.message && <span className="gmail-sendmail-error">{errors.message.message}</span>}
        </div>

        <div className="gmail-sendmail-footer">
          <button 
            type="submit" 
            className="gmail-send-btn"
            disabled={sending}
            data-testid="compose-send-btn"
          >
            {sending ? (
              <>
                <Loader2 size={16} className="gmail-loading-spinner" />
                <span>Sending...</span>
              </>
            ) : (
              <>
                <Send size={16} />
                <span>Send</span>
              </>
            )}
          </button>
          
          <div className="gmail-sendmail-tools">
            <button type="button" className="gmail-icon-btn">
              <Paperclip size={18} />
            </button>
            <button type="button" className="gmail-icon-btn">
              <Link size={18} />
            </button>
            <button type="button" className="gmail-icon-btn">
              <Smile size={18} />
            </button>
            <button type="button" className="gmail-icon-btn">
              <MoreVertical size={18} />
            </button>
          </div>

          <button type="button" className="gmail-icon-btn gmail-delete-draft" onClick={onClose}>
            <Trash2 size={18} />
          </button>
        </div>
      </form>
    </div>
  );
};

export default GmailSendMail;
